import "react-data-grid/lib/styles.css";
import Header from "./datasheets/views/common/Header";
import "./App.css";
import { Provider as JotaiProvider } from "jotai";
import ManageUsers from "datasheets/views/admin/ManageUsers";

interface AppProps {
  testMode?: boolean;
}

function App(props: AppProps) {
  return (
    <JotaiProvider>
      <div className="App">
        <Header />
        <ManageUsers />
      </div>
    </JotaiProvider>
  );
}

export default App;
